module.exports = __webpack_public_path__ + "static/media/400073_01.192b13be.png";